/**
 * Frontend API helper
 * PURPOSE: Centralizes Axios configuration and uploaded-image URL creation.
 *
 * EDITING GUIDE:
 * - Read the comments above each section or function before changing behavior.
 * - Keep validation, authentication and error handling in place for production safety.
 * - Search for "EDIT HERE" to find the most common business-content settings.
 */

import axios from 'axios';

// EDIT HERE: set REACT_APP_API_URL in production when frontend and backend use different domains.
export const API_BASE_URL = String(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 20000,
});

export function assetUrl(filePath) {
  if (!filePath) return '/placeholder.svg';
  if (/^(https?:|data:|blob:)/i.test(filePath)) return filePath;
  const normalizedPath = filePath.startsWith('/') ? filePath : `/${filePath}`;
  return `${API_BASE_URL}${normalizedPath}`;
}
